module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAPAQMAAADao60rAAAABlBMVEVHcEz///+flKJDAAAAAXRSTlMAQObYZgAAABJJREFUCNdj+P//DwMMIwMixAEkMBrLA25HzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/burger.png
// module id = 197
// module chunks = 0